export default {
      id: "error-image-photo-icon-usage",
      viewBox: "0 0 512 462.54",
      url: __webpack_public_path__ + "img/icons.svg#error-image-photo-icon",
      toString: function () {
        return this.url;
      }
    }